import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatButtonModule, MatCheckboxModule, MatToolbarModule, MatSidenavModule, MatIconModule, MatListModule, MatInputModule, MatCardModule, MatTabsModule, MatSnackBarModule, MatExpansionModule, MatBadgeModule, MatPaginatorModule, MatProgressBarModule, MatSelectModule, MatDatepickerModule, MatFormFieldModule} from '@angular/material';
import { LayoutModule } from '@angular/cdk/layout';
import { FlexLayoutModule } from '@angular/flex-layout';
import {ScrollDispatchModule} from '@angular/cdk/scrolling';

let materialModules:any[]=[
  LayoutModule,
  MatToolbarModule,
  MatSidenavModule,
  MatButtonModule,
  MatCheckboxModule,
  MatIconModule,
  MatListModule,
  MatInputModule,
  MatCardModule,
  MatTabsModule,
  MatSnackBarModule,
  MatExpansionModule,
  MatBadgeModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatSelectModule,
  MatDatepickerModule,
  MatFormFieldModule,
  FlexLayoutModule,
  ScrollDispatchModule]
@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    ...materialModules
  ],
  exports: [
    CommonModule,
    ...materialModules
  ],
})
export class MaterialModule { }
